// extracted by mini-css-extract-plugin
module.exports = {"rtl-mode":"htmlToReact_rtl-mode__3Gs-m","rtl-mirror":"htmlToReact_rtl-mirror__RItec","player-wrapper":"htmlToReact_player-wrapper__2nc87","is-init":"htmlToReact_is-init__1lYfd"};